import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../contexts/authContext";

function ProtectedRoute() {
  const { user, profile } = useAuth();
  const location = useLocation();  

  // If user is not authenticated, redirect to login
  if (!user) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} />;
  }

  // If user is not profile complete, only allow complete-profile routes
  if (!user.is_profile_complete) {
    const isProfileCompletionRoute = location.pathname.startsWith('/complete-profile');
    return isProfileCompletionRoute ? 
      <Outlet /> : 
      <Navigate to="/complete-profile/role-selection" replace />;
  }

  // If user is authenticated and profile is complete, render the protected route
  return <Outlet />;
}

export default ProtectedRoute